import { useMemo } from 'react'

import { resolveMissionSubmission } from '../lib/submission'

import { useUserProgress } from '@/shared/contexts/UserProgress'

interface UseMissionSubmissionProps {
  id: number
}

export const useMissionSubmission = ({ id }: UseMissionSubmissionProps) => {
  const { progress } = useUserProgress()
  const mission_submissions = progress?.mission_submissions || []

  const submissions = useMemo(() => {
    return mission_submissions.filter(submission => submission.mission_id == id)
  }, [mission_submissions, id])

  const submission = resolveMissionSubmission(submissions)

  return { submission }
}
